import styles from './QuestionBar.module.scss'
import Icon from "@/components/UI/Icon/Icon";
import {CellToQuestionMapping} from "@/utils/crossword";


type Props = {
  onNextQuestion: () => void
  onPreviousQuestion: () => void
  selectedCell?: {x: number, y: number}
  cellToQuestionMap: CellToQuestionMapping[][]
  goingAcross: boolean
  accrossQuestionMap: Record<string, string>
  downQuestionMap: Record<string, string>
}

const QuestionBar = ({onNextQuestion, selectedCell, cellToQuestionMap, goingAcross, accrossQuestionMap, downQuestionMap, onPreviousQuestion}: Props) => {

  if (!selectedCell) return null

  const currentQuestionNumber = cellToQuestionMap[selectedCell.y][selectedCell.x][goingAcross ? 'across' : 'down']
  const currentQuestion = goingAcross ? accrossQuestionMap[currentQuestionNumber] : downQuestionMap[currentQuestionNumber]

  return (
    <div className={styles.bar}>
      <div className={styles.innerBar}>
        <a className={styles.button}>
          <Icon icon="chevronLeft" onClick={onPreviousQuestion}/>
        </a>

        <div>{currentQuestion}</div>

        <a className={styles.button}>
          <Icon icon="chevronRight" onClick={onNextQuestion}/>
        </a>

      </div>
    </div>
  )
}

export default QuestionBar;
